import type { GlobalSearchItemDto } from '@sib/api';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const RECENT_SEARCHES_LIMIT = 8;
const STORAGE_KEY = 'global-search-recent-items';

const getRecentSearchItemKey = (item: GlobalSearchItemDto) =>
  `${item.module}:${item.id}`;

interface RecentGlobalSearchesStore {
  items: GlobalSearchItemDto[];
  addItem: (item: GlobalSearchItemDto) => void;
}

export const useRecentGlobalSearches = create<RecentGlobalSearchesStore>()(
  persist(
    (set, get) => ({
      items: [],
      addItem: item => {
        const existing = get().items.filter(
          stored =>
            getRecentSearchItemKey(stored) !== getRecentSearchItemKey(item)
        );

        set({
          items: [item, ...existing].slice(0, RECENT_SEARCHES_LIMIT),
        });
      },
    }),
    { name: STORAGE_KEY }
  )
);
